module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- src/app/commons/templates/HolidaysList.ejs -->\n<thead>\n    <tr>\n        <th width="170px">Date</th>\n        <th>Title</th>\n        <th width="80px">Enabled</th>\n    </tr>\n</thead>\n<tbody class="js-model-views">\n    <tr class="empty-table-msg js-empty">\n        <td colspan="3">\n            <h2>No holidays found</h2>\n        </td>\n    </tr>\n</tbody>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/commons/templates/HolidaysList.ejs
// module id = 858
// module chunks = 1